import * as React from "react";
import { withStyles, WithStyles, Typography, Link } from "@material-ui/core";
import styles from "../../styles/generic/banner";
import { withCustomStyles } from "../hocs/with-custom-styles";
import { CustomStyles } from "../../types";

/**
 * Interface describing component props
 */
interface Props extends WithStyles<typeof styles> {
  customStyles?: CustomStyles;
}

/**
 * Banner component
 *
 * @param props component props
 */
const Banner: React.FC<Props> = ({ classes, customStyles }) => {

  return (
    <div
      className={ classes.root }
      style={ customStyles?.root }
    >
      <div
        className={ classes.banner }
        style={ customStyles?.banner }
      >
        <div className={ classes.bannerInfoContainer }>
          <Typography
            variant="h4"
            className={ classes.bannerHeading }
            style={ customStyles?.bannerHeading }
          >
            { "Kouvolan Varaamo-tilanvarausjärjestelmä on suljettu." }
          </Typography>

          {/* 
          Closing information 
          */}
          <div
            className={ classes.bannerClosingDiv }
            style={ customStyles?.bannerClosingDiv }>
              <Typography
                variant="subtitle1"
                className={ classes.bannerDescription }
                style={ customStyles?.bannerDescription }>
                  {"Ennen kuin uusi ajanvarausohjelma saadaan käyttöön, varaukset tulee tehdä ottamalla yhteyttä kirjastoon." }
              </Typography>  
               
              <div
                className={ classes.bannerDescriptionDiv }
                style={ customStyles?.bannerDescriptionDiv }>
                  <Typography
                    variant="subtitle1"
                    className={ classes.bannerDescription1 }
                    style={ customStyles?.bannerDescription1}>
                    {"Uusi ajanvarausohjelma otetaan käyttöön tammikuun 2026 alkupuolella. Tiedotamme uuden järjestelmän käyttöönotosta tarkemmin Kyyti-verkkokirjastossa " }
                  </Typography>  
                  <Link
                    href="https://kyyti.finna.fi/"
                    variant="subtitle1"
                    className={ classes.bannerLink }
                    style={ customStyles?.bannerLink }>
                      {"https://kyyti.finna.fi/. "}
                  </Link> 
              </div>
              <div
                className={ classes.bannerDescriptionDiv }
                style={ customStyles?.bannerDescriptionDiv }>
                  <Typography
                    variant="subtitle1"
                    className={ classes.bannerDescription1 }
                    style={ customStyles?.bannerDescription1 }>
                      {"Kiitos kärsivällisyydestänne muutostilanteessa! Lisätietoja saat tarvittaessa kirjaston henkilökunnalta. "}
                  </Typography>  
              </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

const Styled = withStyles(styles)(Banner);
const CustomStyled = withCustomStyles("generic/banner")(Styled);

export default CustomStyled;